/** 
 * @packageDocumentation
 * @module ErBsClient
 **/

export enum MasteryCodes {
	'None' = 0,
	'Glove' = 1,
	'Tonfa' = 2,
	'Bat' = 3,
	'Whip' = 4,
	'HighAngleFire' = 5,
	'DirectFire' = 6,
	'Bow' = 7,
	'CrossBow' = 8,
	'Pistol' = 9,
	'AssaultRifle' = 10,
	'SniperRifle' = 11,
	'Cannon' = 12,
	'Hammer' = 13,
	'Axe' = 14,
	'OneHandSword' = 15,
	'TwoHandSword' = 16,
	'Polearm' = 17,
	'DualSword' = 18,
	'Spear' = 19,
	'Nunchaku' = 20,
	'Rapier' = 21,
	'Guitar' = 22,
	'Trap' = 101,
	'Craft' = 102,
	'Search' = 103,
	'Move' = 104,
	'Health' = 201,
	'Defense' = 202,
	'Meditation' = 203,
	'Hunt' = 204
}
